import React from 'react'

import AtomIconButton, {
  IconButtonProps as AtomIconButtonProps
} from 'components_new/atoms/IconButton'
import Icon, { IconName } from 'components_new/atoms/Icon'
import Tooltip from 'components_new/atoms/Tooltip'
import LoadingSpinner from 'components_new/atoms/LoadingSpinner'

export interface IconButtonProps extends Omit<AtomIconButtonProps, 'children'> {
  loading?: boolean
  loadingTitle?: string
  name: IconName
  title?: string
}

const IconButton = React.forwardRef((props: IconButtonProps, ref: any) => {
  const { loading, loadingTitle, name, onClick, sx, title, ...rest } = props

  return (
    <Tooltip title={loading ? loadingTitle : title}>
      <AtomIconButton
        {...rest}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()

          if (onClick) onClick(e)
        }}
        ref={ref}
        sx={{
          ...(props.variant === 'outlined'
            ? { border: '1px solid', borderColor: 'divider' }
            : null),
          ...sx
        }}
      >
        {loading ? (
          <LoadingSpinner size={props.size === 'small' ? 20 : 24} />
        ) : (
          <Icon fontSize={props.size} name={name} />
        )}
      </AtomIconButton>
    </Tooltip>
  )
})

IconButton.displayName = 'IconButton'
export default IconButton
